(function () {
  'use strict';

  // Run the counter. Called on DOMContentLoaded AND after every
  // section re-render (colors.js replaces .item-info on variant change).
  function initCounter() {
    var dataEl = document.querySelector('[id^="fmb-ec-data-"]');
    if (!dataEl) return;

    var sid = dataEl.id.replace('fmb-ec-data-', '');

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var map = {};
    data.variants.forEach(function (v) { map[v.id] = v; });
    var editionSize = data.editionSize || 25;

    function getVariantId() {
      // productSelect is a hidden input updated by the product form
      var sel = document.getElementById('productSelect-' + sid);
      if (sel && sel.value) return parseInt(sel.value, 10);

      // ProductCurrentVariantJson is updated by colors.js fetch
      var json = document.getElementById('ProductCurrentVariantJson-' + sid);
      if (json && json.textContent.trim()) {
        try {
          var parsed = JSON.parse(json.textContent);
          if (parsed && parsed.id) return parsed.id;
        } catch (e) {}
      }
      return null;
    }

    function render(vid) {
      var v = vid ? map[vid] : null;
      if (!v) {
        // Fall back to first variant
        var firstKey = Object.keys(map)[0];
        if (!firstKey) return;
        v = map[parseInt(firstKey, 10)];
      }

      var claimedEl = document.getElementById('fmb-ec-claimed-' + sid);
      var remEl     = document.getElementById('fmb-ec-rem-' + sid);
      var fillEl    = document.getElementById('fmb-ec-fill-' + sid);
      var dotEl     = document.getElementById('fmb-ec-dot-' + sid);
      if (!claimedEl || !remEl || !fillEl || !dotEl) return;

      // claimed = editionSize - inventory_quantity (set in Liquid)
      // This works because we manually keep on-hand = editionSize - orders_placed
      var claimed   = Math.max(0, editionSize - v.inventory);
      var remaining = v.tracked === 'shopify' ? Math.max(0, v.inventory) : editionSize;
      var pct       = Math.min(100, Math.round(claimed * 100 / editionSize));

      claimedEl.textContent = claimed;
      fillEl.style.width    = pct + '%';
      dotEl.classList.remove('sold', 'low', 'critical');

      if (remaining === 0) {
        remEl.textContent = 'Sold Out';
        dotEl.classList.add('sold');
        fillEl.style.background = '#c0392b';
      } else if (remaining <= 4) {
        remEl.textContent = 'Only ' + remaining + ' left — almost gone';
        dotEl.classList.add('critical');
        fillEl.style.background = 'linear-gradient(90deg,rgba(211,84,0,.45),#d35400)';
      } else if (remaining <= 8) {
        remEl.textContent = 'Only ' + remaining + ' left';
        dotEl.classList.add('low');
        fillEl.style.background = 'linear-gradient(90deg,rgba(241,196,15,.45),#f39c12)';
      } else {
        remEl.textContent = remaining + ' remaining';
        fillEl.style.background = 'linear-gradient(90deg,rgba(201,169,110,.45),#c9a96e)';
      }
    }

    // Render immediately with current variant
    render(getVariantId());

    // Re-render on radio change (variant swatches)
    // Use event delegation on document so it survives innerHTML replacement
    document.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      setTimeout(function () { render(getVariantId()); }, 100);
      setTimeout(function () { render(getVariantId()); }, 600);
    });
  }

  // 1. Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounter);
  } else {
    initCounter();
  }

  // 2. After colors.js replaces .item-info via fetch, re-init the counter.
  // colors.js calls `new Colors.Product(container)` after innerHTML swap,
  // which re-inits variants. We observe the counter element being re-inserted.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        // If the counter element or its ancestor was re-inserted
        if (
          node.querySelector && node.querySelector('[id^="fmb-ec-data-"]') ||
          (node.id && node.id.indexOf('fmb-ec-data-') === 0)
        ) {
          setTimeout(initCounter, 50);
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();